export const getShowReferralDialog = ({ showReferralDialog }) =>
  showReferralDialog;

export const getSetShowReferralDialog = ({ setShowReferralDialog }) =>
  setShowReferralDialog;
